import React, {  
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  Layout,
  Drawer,
  Button,
  Input,
  Tooltip,
  Modal,
} from "antd";

import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DashboardOutlined,
  BarChartOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
  SearchOutlined,
  SafetyCertificateOutlined,
  SolutionOutlined,
  ApartmentOutlined,
  BookOutlined,
  IdcardOutlined,
  AccountBookOutlined,
  CheckSquareOutlined,
  CloseOutlined,
} from "@ant-design/icons";

import ChangeUserPassword from "./ChangeUserPassword";

import {
  FaReceipt,
  FaGraduationCap,
} from "react-icons/fa";

import { motion } from "framer-motion";

// Dashboard
import OverViewAdminOfficer from "./pages/OverViewAdminOfficer";

// User
import UserSearchBox from "../SchoolDashApp/UserDetails/UserSearchBox";
import UserDetailsPage from "../SchoolDashApp/UserDetails/UserDetailsPage";
import ProfileImage from "./ProfileImage";
import AddStudentsStaff from "./NewStudents/AddStudentsStaff";

// Students
import AdmissionForm from "./NewStudents/AdmissionForm/AdmissionForm";
import StudentAdmission from "./NewStudents/AdmissionForm/StudentAdmission";

// Results
import GradeDistribution from "../pages/Reportcard/GradeDistribution";
import ReportCard from "./ReportCard";
import PromotionDashboard from "./AcademyYearSelection/PromotionDashboard";

// Academic
import ClassViewList from "../SchoolDashApp/Class/ClassViewList";
import SubjectViewList from "../SchoolDashApp/Class/Subjects/SubjectViewList";
import HighAveragesPage from "../SchoolDashApp/ReportCard/HighAveragesPage";
import StudentStatusSummary from "../SchoolDashApp/StudentStatusSummary";
import PeriodReport from "../pages/Reportcard/PeriodReport";
import TopStudentPerPeriod from "../SchoolDashApp/ReportCard/TopStudentPerPeriod";

// Student services
import CertificateDashboard from "./certificate/CertificateDashboard";
import StudentsIDCard from "../pages/Students/IdCards/StudentsIDCard";

// Other
import Darkmode from "./Darkmode/Darkmode";
import NotificationIcon from "../components/ChatApp/NotificationIcon";
import Notice from "../components/ChatApp/Notice";
import ComplaintUnit from "../Dashboard/ComplaintUnit";

// Todo
import PostTodoList from "./CalenderAndTodo/PostTodoList";

import logo from "./zpa.png";

const { Header, Sider, Content } = Layout;

/* ============================================================
   ZION PRAISE ACADEMY
   DEEP NAVY BLUE • GOLD • BLACK • WHITE
============================================================ */

const COLORS = {
  primary: "#0A2A43",
  primaryDark: "#071D2F",
  primaryDeep: "#04131F",
  secondary: "#123F63",

  page: "#F5F7FA",
  pureWhite: "#FFFFFF",
  text: "#111827",
  muted: "#667085",
  border: "#D9E0E7",
  soft: "#F8FAFC",

  success: "#198754",
  warning: "#C58A00",
  error: "#B42318",
  info: "#1D5F8C",

  sidebar: "#050B12",
  sidebarAlt: "#0A1724",
  sidebarBorder: "#1B3042",
  sidebarText: "#E8EEF3",
  sidebarMuted: "#91A4B3",
  sidebarIcon: "#9EB2C1",
  sidebarBright: "#F6C944",

  gold: "#F6C944",
  yellow: "#EAB308",
  orange: "#C58A00",
  green: "#198754",
  emerald: "#22A06B",
  sky: "#1D5F8C",
  antique: "#B99A52",

  black: "#050B12",
  white: "#F8FAFC",
  gray: "#A7B4BF",

  shadow:
    "0 12px 35px rgba(5,11,18,.10)",
};

/* ============================================================
   SIDEBAR ITEMS
============================================================ */

const menuItems = [
  {
    key: "overview",
    icon: <DashboardOutlined />,
    label: "Dashboard",
  },

  {
    key: "studentsadmission",
    icon: <UsergroupAddOutlined />,
    label: "Students Admission",
  },

  {
    key: "admissionlist",
    icon: <TeamOutlined />,
    label: "Students List",
  },

  {
    key: "promotion",
    icon: <FaGraduationCap />,
    label: "Student Promotion",
  },

  {
    key: "statusrecord",
    icon: <SolutionOutlined />,
    label: "Students Status Record",
  },

  {
    key: "complaintunit",
    icon: <IdcardOutlined />,
    label: "Manage Students Complaints",
  },

  {
    key: "studentsidcards",
    icon: <IdcardOutlined />,
    label: "Generate ID Cards",
  },

  {
    key: "studentscertificate",
    icon: <SafetyCertificateOutlined />,
    label: "Students Certificate",
  },

  {
    key: "classviewlist",
    icon: <ApartmentOutlined />,
    label: "Grade Classes",
  },

  {
    key: "subjectviewlist",
    icon: <BookOutlined />,
    label: "Courses Listing",
  },

  {
    key: "gradedistribution",
    icon: <BarChartOutlined />,
    label: "Grade Distribution",
  },

  {
    key: "highaverages",
    icon: <BarChartOutlined />,
    label: "High Yearly Averages",
  },

  {
    key: "topstudents",
    icon: <FaGraduationCap />,
    label: "Top Students",
  },

  {
    key: "periodicreport",
    icon: <AccountBookOutlined />,
    label: "Periodic Report",
  },

  {
    key: "reportcard",
    icon: <FaReceipt />,
    label: "Report Card",
  },

    {
      key: "systemusers",
      icon: <UsergroupAddOutlined />,
      label: "Add System Users",
    },

];

/* ============================================================
   SIDEBAR SECTIONS
============================================================ */

const navigationSections = [
  {
    key: "command",
    title: "COMMAND CENTER",
    items: [
      "overview",
    ],
  },

  {
    key: "admissions",
    title: "ADMISSIONS & STUDENTS",
    items: [
      "studentsadmission",
      "admissionlist",
      "promotion",
      "systemusers",
      "statusrecord",
      "complaintunit",
    ],
  },

  {
    key: "student-services",
    title: "STUDENT SERVICES",
    items: [
      "studentsidcards",
      "studentscertificate",
    ],
  },

  {
    key: "academic",
    title: "ACADEMIC INFORMATION",
    items: [
      "classviewlist",
      "subjectviewlist",
      "gradedistribution",
      "highaverages",
      "topstudents",
      "periodicreport",
      "reportcard",
    ],
  },
];

/* ============================================================
   MAIN DASHBOARD
============================================================ */

const AdmissionOfficialDashboard = () => {
  const [collapsed, setCollapsed] =
    useState(false);

  const [drawerOpen, setDrawerOpen] =
    useState(false);

  const [darkMode, setDarkMode] =
    useState(false);

  const [activePage, setActivePage] =
    useState("overview");

  const [selectedUser, setSelectedUser] =
    useState(null);

  const [menuSearch, setMenuSearch] =
    useState("");

  const [todoOpen, setTodoOpen] =
    useState(false);

  const [passwordSettingOpen, setPasswordSettingOpen] =
    useState(false);

  const [isMobile, setIsMobile] =
    useState(
      typeof window !== "undefined"
        ? window.innerWidth < 900
        : false
    );

  const [isNavigating, setIsNavigating] =
    useState(false);

  const [pendingPage, setPendingPage] =
    useState(null);

  /* ==========================================================
     RESPONSIVE HANDLING
  ========================================================== */

  useEffect(() => {
    const handleResize = () => {
      const mobile =
        window.innerWidth < 900;

      setIsMobile(mobile);

      if (mobile) {
        setCollapsed(false);
      }
    };

    handleResize();

    window.addEventListener(
      "resize",
      handleResize
    );

    return () => {
      window.removeEventListener(
        "resize",
        handleResize
      );
    };
  }, []);

  /* ==========================================================
     GLOBAL DASHBOARD STYLES
  ========================================================== */

  useEffect(() => {
    const style =
      document.createElement("style");

    style.id =
      "admission-officer-dashboard-styles";

    style.innerHTML = `
      * {
        box-sizing: border-box;
      }

      html,
      body,
      #root {
        margin: 0;
        min-height: 100%;
      }

      body {
        overflow: hidden;
        background:
          linear-gradient(
            135deg,
            #F5F7FA 0%,
            #FFFFFF 50%,
            #F3F6F9 100%
          );
        color: #111827;
      }

      ::-webkit-scrollbar {
        width: 7px;
        height: 7px;
      }

      ::-webkit-scrollbar-track {
        background: transparent;
      }

      ::-webkit-scrollbar-thumb {
        background: #A7B4BF;
        border-radius: 20px;
      }

      ::-webkit-scrollbar-thumb:hover {
        background: #0A2A43;
      }

      * {
        scrollbar-width: thin;
        scrollbar-color:
          #A7B4BF
          transparent;
      }

      /* ======================================================
         HEADER MENU BUTTON
      ====================================================== */

      .admission-menu-button {
        width: 39px !important;
        height: 39px !important;
        min-width: 39px !important;
        padding: 0 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        flex-shrink: 0 !important;
        border-radius: 9px !important;
        border: 1px solid #D9E0E7 !important;
        background: #FFFFFF !important;
        color: #0A2A43 !important;
        box-shadow: none !important;
        transition: all 180ms ease !important;
      }

      .admission-menu-button:hover {
        color: #0A2A43 !important;
        border-color: #D4A017 !important;
        background: #FFF9E6 !important;
      }

      .admission-dark
      .admission-menu-button {
        background: #101D29 !important;
        border-color: #263B4C !important;
        color: #F6C944 !important;
      }

      /* ======================================================
         HEADER SEARCH
      ====================================================== */

      .admission-search-box {
        min-width: 0;
      }

      .admission-search-box
      .ant-input-affix-wrapper {
        min-height: 39px !important;
        border-radius: 9px !important;
        border: 1px solid #D9E0E7 !important;
        background: #FFFFFF !important;
        box-shadow: none !important;
      }

      .admission-search-box
      .ant-input-affix-wrapper:hover {
        border-color: #B99A52 !important;
      }

      .admission-search-box
      .ant-input-affix-wrapper-focused {
        border-color: #0A2A43 !important;
        box-shadow:
          0 0 0 2px
          rgba(10,42,67,.10) !important;
      }

      .admission-search-box
      .ant-input {
        color: #111827 !important;
      }

      .admission-search-box
      .ant-input::placeholder {
        color: #8793A0 !important;
      }

      .admission-dark
      .admission-search-box
      .ant-input-affix-wrapper {
        background: #101D29 !important;
        border-color: #263B4C !important;
      }

      .admission-dark
      .admission-search-box
      .ant-input {
        color: #F8FAFC !important;
      }

      /* ======================================================
         SIDEBAR SEARCH
      ====================================================== */

      .admission-sidebar-search
      .ant-input-affix-wrapper {
        min-height: 39px !important;
        border-radius: 8px !important;
        background: #0A1724 !important;
        border: 1px solid #1F3548 !important;
        box-shadow: none !important;
      }

      .admission-sidebar-search
      .ant-input-affix-wrapper:hover {
        border-color: #A98525 !important;
      }

      .admission-sidebar-search
      .ant-input {
        background: transparent !important;
        color: #EEF3F7 !important;
      }

      .admission-sidebar-search
      .ant-input::placeholder {
        color: #718697 !important;
      }

      .admission-sidebar-search
      .ant-input-affix-wrapper-focused {
        border-color: #F6C944 !important;
        box-shadow:
          0 0 0 2px
          rgba(246,201,68,.12) !important;
      }

      /* ======================================================
         SIDEBAR SCROLL
      ====================================================== */

      .admission-sidebar-scroll {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        overflow-x: hidden;
        padding-bottom: 28px;
        scrollbar-width: thin;
        scrollbar-color:
          rgba(246,201,68,.50)
          transparent;
      }

      .admission-sidebar-scroll::-webkit-scrollbar {
        width: 6px;
      }

      .admission-sidebar-scroll::-webkit-scrollbar-track {
        background: transparent;
      }

      .admission-sidebar-scroll::-webkit-scrollbar-thumb {
        background:
          linear-gradient(
            180deg,
            rgba(246,201,68,.75),
            rgba(185,154,82,.50)
          );
        border-radius: 20px;
      }

      .admission-sidebar-scroll::-webkit-scrollbar-thumb:hover {
        background:
          linear-gradient(
            180deg,
            #F6C944,
            #B99A52
          );
      }

      /* ======================================================
         SIDEBAR SECTION TITLES
      ====================================================== */

      .admission-section-title {
        padding: 16px 18px 7px;
        color: #8496A5;
        font-size: 9px;
        font-weight: 800;
        letter-spacing: 1.25px;
        user-select: none;
      }

      /* ======================================================
         SIDEBAR NAVIGATION
      ====================================================== */

      .admission-nav-item {
        position: relative;
        width: calc(100% - 24px);
        min-height: 43px;
        margin: 2px 12px;
        padding: 0 12px;
        border: 0;
        border-radius: 8px;
        display: flex;
        align-items: center;
        gap: 11px;
        color: #C7D3DC;
        background: transparent;
        cursor: pointer;
        text-align: left;
        font-family: inherit;
        font-size: 13px;
        font-weight: 500;
        transition:
          background 150ms ease,
          color 150ms ease,
          transform 150ms ease;
      }

      .admission-nav-item:hover {
        background:
          linear-gradient(
            90deg,
            rgba(10,42,67,.95),
            rgba(10,42,67,.42)
          );
        color: #FFFFFF;
      }

      .admission-nav-item:hover
      .admission-nav-icon {
        color: #F6C944;
        border-color:
          rgba(246,201,68,.22);
        background:
          rgba(246,201,68,.08);
      }

      .admission-nav-item.active {
        background:
          linear-gradient(
            90deg,
            rgba(10,42,67,.98),
            rgba(18,63,99,.78),
            rgba(5,11,18,.30)
          );
        color: #FFFFFF;
        font-weight: 700;
        box-shadow:
          0 6px 18px
          rgba(0,0,0,.24);
      }

      .admission-nav-item.active::before {
        content: "";
        position: absolute;
        left: 0;
        top: 7px;
        bottom: 7px;
        width: 3px;
        border-radius:
          0 3px 3px 0;
        background:
          linear-gradient(
            180deg,
            #F6C944,
            #D4A017
          );
        box-shadow:
          0 0 10px
          rgba(246,201,68,.55);
      }

      .admission-nav-item.active
      .admission-nav-icon {
        color: #F6C944;
        border-color:
          rgba(246,201,68,.28);
        background:
          rgba(246,201,68,.10);
      }

      .admission-nav-icon {
        width: 28px;
        height: 28px;
        min-width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 7px;
        color: #9EB2C1;
        border: 1px solid transparent;
        font-size: 15px;
        transition: all 150ms ease;
      }

      .admission-nav-label {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 1.2;
      }

      .admission-nav-chevron {
        margin-left: auto;
        opacity: 0;
        transform: translateX(-3px);
        transition: all 150ms ease;
        color: #F6C944;
      }

      .admission-nav-item:hover
      .admission-nav-chevron,
      .admission-nav-item.active
      .admission-nav-chevron {
        opacity: 1;
        transform: translateX(0);
      }

      .admission-collapsed-item {
        width: calc(100% - 18px);
        justify-content: center;
        margin-left: 9px;
        margin-right: 9px;
        padding: 0;
      }

      .admission-collapsed-item
      .admission-nav-chevron {
        display: none;
      }

      .admission-collapsed-item
      .admission-nav-label {
        display: none;
      }

      .admission-collapsed-item
      .admission-nav-icon {
        width: 34px;
        height: 34px;
        min-width: 34px;
      }

      /* ======================================================
         HEADER ACTIONS
      ====================================================== */

      .admission-header-actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 8px;
        flex-shrink: 0;
        min-width: max-content;
      }

      .admission-header-action {
        width: 39px;
        height: 39px;
        min-width: 39px;
        padding: 0;
        border-radius: 9px;
        border: 1px solid #D9E0E7;
        background: #FFFFFF;
        color: #294A62;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 160ms ease;
        flex-shrink: 0;
      }

      .admission-header-action:hover {
        color: #0A2A43;
        border-color: #D4A017;
        background: #FFF9E6;
      }

      .admission-dark
      .admission-header-action {
        background: #101D29;
        border-color: #263B4C;
        color: #E8EEF3;
      }

      /* ======================================================
         PROFILE
      ====================================================== */

      .admission-profile-container {
        width: 40px;
        height: 40px;
        min-width: 40px;
        border-radius: 50%;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px solid #F6C944;
        background: #FFFFFF;
        box-shadow:
          0 3px 12px
          rgba(5,11,18,.18);
        position: relative;
        flex-shrink: 0;
      }

      .admission-profile-avatar {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        border-radius: 50%;
      }

      .admission-profile-container > *,
      .admission-profile-avatar > * {
        width: 100% !important;
        height: 100% !important;
        min-width: 0 !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }

      .admission-profile-container img,
      .admission-profile-avatar img {
        width: 100% !important;
        height: 100% !important;
        min-width: 100% !important;
        min-height: 100% !important;
        object-fit: cover !important;
        object-position: center !important;
        display: block !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      /* ======================================================
         WORKSPACE
      ====================================================== */

      .admission-workspace {
        border: 1px solid #D9E0E7;
        background: #FFFFFF;
        border-radius: 11px;
        min-height:
          calc(100vh - 111px);
        box-shadow:
          0 4px 18px
          rgba(5,11,18,.045);
        position: relative;
        overflow: hidden;
      }

      .admission-workspace::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 3px;
        background:
          linear-gradient(
            90deg,
            #071D2F 0%,
            #0A2A43 45%,
            #F6C944 100%
          );
        opacity: .9;
        pointer-events: none;
      }

      .admission-workspace-dark {
        background: #101D29;
        border-color: #263B4C;
      }

      .admission-workspace-dark::before {
        opacity: 1;
      }

      /* ======================================================
         PAGE HEADING
      ====================================================== */

      .admission-page-heading {
        min-height: 34px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        margin-bottom: 8px;
        padding: 0 2px;
      }

      .admission-page-heading-left {
        min-width: 0;
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .admission-page-heading-line {
        width: 4px;
        height: 18px;
        min-width: 4px;
        border-radius: 3px;
        background:
          linear-gradient(
            180deg,
            #0A2A43,
            #F6C944
          );
        box-shadow:
          0 0 7px
          rgba(10,42,67,.20);
      }

      .admission-page-heading-title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #111827;
        font-size: 14px;
        font-weight: 750;
      }

      .admission-dark
      .admission-page-heading-title {
        color: #F3F8FA;
      }

      .admission-page-heading-meta {
        color: #667085;
        font-size: 10px;
        font-weight: 600;
        white-space: nowrap;
        letter-spacing: .2px;
      }

      .admission-dark
      .admission-page-heading-meta {
        color: #9FB0BD;
      }

      /* ======================================================
         SIDEBAR
      ====================================================== */

      .admission-sidebar-shell {
        position: relative;
        height: 100vh;
        min-height: 100vh;
        overflow: hidden;

        background:
          radial-gradient(
            circle at 18% 10%,
            rgba(246,201,68,.07),
            transparent 23%
          ),
          radial-gradient(
            circle at 88% 82%,
            rgba(29,95,140,.13),
            transparent 27%
          ),
          linear-gradient(
            145deg,
            #050B12 0%,
            #071523 48%,
            #03070C 100%
          );
      }

      .admission-sidebar-shell::after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 1px;
        pointer-events: none;

        background:
          linear-gradient(
            180deg,
            rgba(246,201,68,.08),
            rgba(246,201,68,.32),
            rgba(29,95,140,.24),
            rgba(246,201,68,.06)
          );

        box-shadow:
          0 0 18px
          rgba(246,201,68,.08);
      }

      .admission-sidebar-content {
        position: relative;
        z-index: 2;
        height: 100%;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      /* ======================================================
         NAVIGATION PROGRESS
      ====================================================== */

      .admission-navigation-progress {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 3px;
        z-index: 1000;
        overflow: hidden;
        background:
          rgba(10,42,67,.12);
      }

      .admission-navigation-progress::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height: 100%;

        background:
          linear-gradient(
            90deg,
            #071D2F,
            #0A2A43,
            #F6C944
          );

        box-shadow:
          0 0 8px
          rgba(246,201,68,.40);

        animation:
          admissionNavigationProgress
          2s linear forwards;
      }

      @keyframes admissionNavigationProgress {
        0% {
          width: 0%;
        }

        20% {
          width: 28%;
        }

        50% {
          width: 60%;
        }

        80% {
          width: 85%;
        }

        100% {
          width: 100%;
        }
      }

      .admission-loading-label {
        position: absolute;
        top: 11px;
        left: 50%;
        transform:
          translateX(-50%);
        z-index: 1001;
        padding: 5px 10px;
        border-radius: 6px;

        background:
          linear-gradient(
            135deg,
            rgba(4,19,31,.98),
            rgba(10,42,67,.98)
          );

        color: #FFFFFF;
        font-size: 9px;
        font-weight: 700;
        letter-spacing: .75px;
        text-transform: uppercase;
        white-space: nowrap;

        box-shadow:
          0 5px 15px
          rgba(0,0,0,.22);
      }

      /* ======================================================
         DARK MODE
      ====================================================== */

      .admission-dark {
        color: #F3F8FA;
      }

      .admission-dark
      .admission-nav-item {
        color: #C7D3DC;
      }

      .admission-dark
      .admission-nav-item:hover {
        background:
          linear-gradient(
            90deg,
            rgba(10,42,67,.95),
            rgba(18,63,99,.35)
          );

        color: #FFFFFF;
      }

      .admission-dark
      .admission-nav-item.active {
        background:
          linear-gradient(
            90deg,
            rgba(10,42,67,.98),
            rgba(18,63,99,.60)
          );

        color: #FFFFFF;
      }

      .admission-dark
      .admission-section-title {
        color: #8496A5;
      }

      /* ======================================================
         PASSWORD MODAL
      ====================================================== */

      .admission-password-modal
      .ant-modal-content {
        border-radius: 15px !important;
        overflow: hidden !important;
        padding: 0 !important;
      }

      .admission-password-modal
      .ant-modal-body {
        padding: 0 !important;
      }

      .admission-password-modal
      .change-user-password-link {
        border: none;
        background: #FFF9E6;
        padding: 10px 16px;
        margin: 0;
        color: #8A6500;
        font-size: 14px;
        font-weight: 700;
        border-radius: 8px;
        cursor: pointer;
      }

      .admission-password-modal > div {
        min-height: auto !important;
        padding: 0 !important;
        background: transparent !important;
      }

      .admission-password-modal
      .ant-card {
        max-width: none !important;
        box-shadow: none !important;
        border: 0 !important;
        background: transparent !important;
      }

      /* ======================================================
         MOBILE
      ====================================================== */

      @media (max-width: 899px) {
        .admission-header-actions {
          gap: 6px;
        }

        .admission-profile-container {
          width: 36px;
          height: 36px;
          min-width: 36px;
        }

        .admission-workspace {
          min-height:
            calc(100vh - 96px);
          border-radius: 8px;
        }

        .admission-page-heading {
          min-height: 30px;
        }

        .admission-page-heading-title {
          font-size: 13px;
        }

        .admission-page-heading-meta {
          display: none;
        }
      }

      @media (max-width: 650px) {
        .admission-search-box {
          max-width: none !important;
          flex: 1 1 auto !important;
        }

        .admission-header-actions {
          gap: 5px;
        }

        .admission-header-action {
          width: 36px;
          height: 36px;
          min-width: 36px;
        }

        .admission-profile-container {
          width: 34px;
          height: 34px;
          min-width: 34px;
        }

        .admission-menu-button {
          width: 36px !important;
          height: 36px !important;
          min-width: 36px !important;
        }
      }

      @media (max-width: 480px) {
        .admission-header-actions {
          gap: 4px;
        }

        .admission-header-action {
          width: 34px;
          height: 34px;
          min-width: 34px;
        }

        .admission-profile-container {
          width: 32px;
          height: 32px;
          min-width: 32px;
        }
      }
    `;

    document.head.appendChild(style);

    return () => {
      const existing =
        document.getElementById(
          "admission-officer-dashboard-styles"
        );

      if (existing) {
        existing.remove();
      }
    };
  }, []);

  /* ==========================================================
     THEME
  ========================================================== */

  const theme = useMemo(
    () => ({
      darkMode,

      background: darkMode
        ? "#07131E"
        : COLORS.page,

      sidebar: COLORS.sidebar,

      header: darkMode
        ? "#0D1B27"
        : COLORS.pureWhite,

      card: darkMode
        ? "#101D29"
        : COLORS.pureWhite,

      inputBackground: darkMode
        ? "#101D29"
        : COLORS.pureWhite,

      text: darkMode
        ? "#F3F8FA"
        : COLORS.text,

      secondary: darkMode
        ? "#9FB0BD"
        : COLORS.muted,

      border: darkMode
        ? "#263B4C"
        : COLORS.border,

      primary: COLORS.primary,
      navy: "#071D2F",
      blue: COLORS.secondary,
      gold: COLORS.gold,
      yellow: COLORS.yellow,
      orange: COLORS.orange,
      green: COLORS.green,
      sky: COLORS.sky,
      antique: COLORS.antique,
      black: COLORS.black,
      white: COLORS.white,
    }),
    [darkMode]
  );

  /* ==========================================================
     MENU LOOKUP
  ========================================================== */

  const menuLookup = useMemo(
    () =>
      Object.fromEntries(
        menuItems.map((item) => [
          item.key,
          item,
        ])
      ),
    []
  );

  /* ==========================================================
     SIDEBAR SEARCH
  ========================================================== */

  const filteredSections = useMemo(() => {
    const query = menuSearch
      .trim()
      .toLowerCase();

    if (!query) {
      return navigationSections;
    }

    return navigationSections
      .map((section) => ({
        ...section,

        items:
          section.items.filter(
            (key) =>
              menuLookup[key]?.label
                ?.toLowerCase()
                .includes(query)
          ),
      }))
      .filter(
        (section) =>
          section.items.length > 0
      );
  }, [menuSearch, menuLookup]);

  /* ==========================================================
     ACTIVE TITLE
  ========================================================== */

  const activeTitle =
    selectedUser
      ? "User Details"
      : menuLookup[activePage]?.label ||
        "Dashboard";

  /* ==========================================================
     PAGE RENDERING
  ========================================================== */

  const renderPage = () => {
    if (selectedUser) {
      return (
        <UserDetailsPage
          theme={theme}
          selectedUser={selectedUser}
        />
      );
    }

    switch (activePage) {
      case "overview":
        return (
          <OverViewAdminOfficer
            theme={theme}
          />
        );

      case "studentsadmission":
        return (
          <AdmissionForm
            theme={theme}
          />
        );

      case "admissionlist":
        return (
          <StudentAdmission
            theme={theme}
          />
        );

      case "promotion":
        return (
          <PromotionDashboard
            theme={theme}
          />
        ); 


              case "systemusers":
        return (
          <AddStudentsStaff
            theme={theme}
          />
        );

      case "studentscertificate":
        return (
          <CertificateDashboard
            theme={theme}
          />
        );

      case "studentsidcards":
        return (
          <StudentsIDCard
            theme={theme}
          />
        );

      case "complaintunit":
        return (
          <ComplaintUnit
            theme={theme}
          />
        );

      case "statusrecord":
        return (
          <StudentStatusSummary
            theme={theme}
          />
        );

      case "classviewlist":
        return (
          <ClassViewList
            theme={theme}
          />
        );

      case "subjectviewlist":
        return (
          <SubjectViewList
            theme={theme}
          />
        );

      case "gradedistribution":
        return (
          <GradeDistribution
            theme={theme}
          />
        );

      case "highaverages":
        return (
          <HighAveragesPage
            theme={theme}
          />
        );

      case "topstudents":
        return (
          <TopStudentPerPeriod
            theme={theme}
          />
        );

      case "periodicreport":
        return (
          <PeriodReport
            theme={theme}
          />
        );

      case "reportcard":
        return (
          <ReportCard
            theme={theme}
          />
        );

      default:
        return (
          <OverViewAdminOfficer
            theme={theme}
          />
        );
    }
  };

  /* ==========================================================
     NAVIGATION
  ========================================================== */

  const handleNavigation = (key) => {
    if (isNavigating) {
      return;
    }

    if (
      key === activePage &&
      !selectedUser
    ) {
      if (isMobile) {
        setDrawerOpen(false);
      }

      return;
    }

    setPendingPage(key);
    setIsNavigating(true);
    setSelectedUser(null);
    setMenuSearch("");

    if (isMobile) {
      setDrawerOpen(false);
    }

    window.setTimeout(() => {
      setActivePage(key);
      setPendingPage(null);
      setIsNavigating(false);
    }, 700);
  };

  /* ==========================================================
     NAVIGATION ITEM
  ========================================================== */

  const renderNavigationItem = (item) => {
    const active =
      activePage === item.key &&
      !selectedUser;

    return (
      <Tooltip
        key={item.key}
        title={
          collapsed
            ? item.label
            : ""
        }
        placement="right"
      >
        <button
          type="button"
          className={[
            "admission-nav-item",
            active
              ? "active"
              : "",
            collapsed
              ? "admission-collapsed-item"
              : "",
          ].join(" ")}
          onClick={() =>
            handleNavigation(
              item.key
            )
          }
          disabled={isNavigating}
          aria-current={
            active
              ? "page"
              : undefined
          }
        >
          <span className="admission-nav-icon">
            {item.icon}
          </span>

          <span className="admission-nav-label">
            {item.label}
          </span>

          <span className="admission-nav-chevron">
            <span
              style={{
                display: "flex",
                fontSize: 9,
              }}
            >
              ›
            </span>
          </span>
        </button>
      </Tooltip>
    );
  };

  /* ==========================================================
     SIDEBAR
  ========================================================== */

  const sidebar = (
    <div className="admission-sidebar-shell">
      <div className="admission-sidebar-content">
        <div
          style={{
            height: "100%",
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            background: "transparent",
          }}
        >
          {/* ==================================================
              BRAND HEADER
          ================================================== */}

          <div
            style={{
              height: 72,
              minHeight: 72,
              display: "flex",
              alignItems: "center",
              justifyContent:
                collapsed
                  ? "center"
                  : "flex-start",
              gap: 11,
              padding:
                collapsed
                  ? "0 10px"
                  : "0 18px",
              borderBottom:
                "1px solid rgba(246,201,68,.14)",
              flexShrink: 0,
            }}
          >
            <div
              style={{
                width: 38,
                height: 38,
                minWidth: 38,
                borderRadius: 8,
                padding: 2,
                background: "#FFFFFF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                border:
                  "1px solid rgba(246,201,68,.45)",
                boxShadow:
                  "0 4px 14px rgba(0,0,0,.25)",
              }}
            >
              <img
                src={logo}
                alt="Zion Praise Academy logo"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: 6,
                  display: "block",
                }}
              />
            </div>

            {!collapsed && (
              <div
                style={{
                  minWidth: 0,
                }}
              >
                <div
                  style={{
                    color: "#F4F9FB",
                    fontSize: 13,
                    fontWeight: 800,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    letterSpacing: ".15px",
                  }}
                >
                  ZION PRAISE ACADEMY
                </div>

                <div
                  style={{
                    marginTop: 3,
                    color: "#F6C944",
                    fontSize: 8,
                    fontWeight: 800,
                    letterSpacing: 1.05,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  ADMISSION OFFICER PORTAL
                </div>
              </div>
            )}
          </div>

          {/* ==================================================
              SIDEBAR SEARCH
          ================================================== */}

          {!collapsed && (
            <div
              className="admission-sidebar-search"
              style={{
                padding:
                  "13px 12px 6px",
                flexShrink: 0,
              }}
            >
              <Input
                allowClear
                value={menuSearch}
                onChange={(event) =>
                  setMenuSearch(
                    event.target.value
                  )
                }
                placeholder="Find a module..."
                prefix={
                  <SearchOutlined
                    style={{
                      color:
                        COLORS.gold,
                    }}
                  />
                }
              />
            </div>
          )}

          {/* ==================================================
              NAVIGATION
          ================================================== */}

          <div className="admission-sidebar-scroll">
            {filteredSections.length ===
              0 && (
              <div
                style={{
                  padding:
                    "35px 20px",
                  textAlign: "center",
                  color: "#718697",
                  fontSize: 11,
                }}
              >
                No module found
              </div>
            )}

            {filteredSections.map(
              (section) => {
                const items =
                  section.items
                    .map(
                      (key) =>
                        menuLookup[key]
                    )
                    .filter(Boolean);

                if (!items.length) {
                  return null;
                }

                return (
                  <div
                    key={section.key}
                  >
                    {!collapsed ? (
                      <div className="admission-section-title">
                        {section.title}
                      </div>
                    ) : (
                      <div
                        style={{
                          height: 12,
                        }}
                      />
                    )}

                    {items.map(
                      renderNavigationItem
                    )}
                  </div>
                );
              }
            )}
          </div>
        </div>
      </div>
    </div>
  );

  /* ==========================================================
     MAIN RETURN
  ========================================================== */

  return (
    <div
      className={
        darkMode
          ? "admission-dark"
          : ""
      }
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 999,
        overflow: "hidden",
        background:
          theme.background,
      }}
    >
      <Layout
        style={{
          height: "100vh",
          minHeight: "100vh",
          background:
            theme.background,
        }}
      >
        {/* ====================================================
            DESKTOP SIDEBAR
        ==================================================== */}

        {!isMobile && (
          <Sider
            width={292}
            collapsedWidth={78}
            collapsed={collapsed}
            trigger={null}
            style={{
              position: "fixed",
              top: 0,
              bottom: 0,
              left: 0,
              height: "100vh",
              zIndex: 100,
              overflow: "hidden",
              background:
                COLORS.sidebar,
            }}
          >
            {sidebar}
          </Sider>
        )}

        {/* ====================================================
            MOBILE SIDEBAR
        ==================================================== */}

        {isMobile && (
          <Drawer
            open={drawerOpen}
            placement="left"
            width={310}
            closable={false}
            onClose={() =>
              setDrawerOpen(false)
            }
            styles={{
              body: {
                padding: 0,
                background:
                  COLORS.sidebar,
                overflow: "hidden",
              },
            }}
          >
            <div
              style={{
                position:
                  "absolute",
                top: 13,
                right: 13,
                zIndex: 20,
              }}
            >
              <Button
                type="text"
                icon={
                  <CloseOutlined />
                }
                onClick={() =>
                  setDrawerOpen(false)
                }
                style={{
                  width: 34,
                  height: 34,
                  color: "#E8EEF3",
                  background:
                    "rgba(246,201,68,.08)",
                  border:
                    "1px solid rgba(246,201,68,.18)",
                  borderRadius: 8,
                  display: "flex",
                  alignItems:
                    "center",
                  justifyContent:
                    "center",
                }}
              />
            </div>

            {sidebar}
          </Drawer>
        )}

        {/* ====================================================
            MAIN LAYOUT
        ==================================================== */}

        <Layout
          style={{
            marginLeft: isMobile
              ? 0
              : collapsed
                ? 78
                : 292,
            height: "100vh",
            minHeight: "100vh",
            background:
              theme.background,
            transition:
              "margin-left 180ms ease",
          }}
        >
          {/* ==================================================
              HEADER
          ================================================== */}

          <Header
            style={{
              height: 68,
              minHeight: 68,
              flexShrink: 0,
              padding: isMobile
                ? "0 9px"
                : "0 16px",
              display: "flex",
              alignItems: "center",
              gap: isMobile ? 6 : 10,
              background:
                theme.header,
              borderBottom:
                `1px solid ${theme.border}`,
              position: "relative",
              zIndex: 30,
            }}
          >
            {isNavigating && (
              <>
                <div className="admission-navigation-progress" />

                <div className="admission-loading-label">
                  Opening{" "}
                  {menuLookup[
                    pendingPage
                  ]?.label ||
                    "module"}
                </div>
              </>
            )}

            {/* Sidebar toggle */}

            <Button
              type="text"
              className="admission-menu-button"
              icon={
                isMobile ? (
                  <MenuUnfoldOutlined />
                ) : collapsed ? (
                  <MenuUnfoldOutlined />
                ) : (
                  <MenuFoldOutlined />
                )
              }
              onClick={() => {
                if (isMobile) {
                  setDrawerOpen(true);
                } else {
                  setCollapsed(
                    (value) =>
                      !value
                  );
                }
              }}
            />

            {/* User Search */}

            <div
              className="admission-search-box"
              style={{
                flex: 1,
                minWidth: 0,
                maxWidth: isMobile
                  ? 270
                  : 450,
              }}
            >
              <UserSearchBox
                theme={theme}
                setSelectedUser={
                  setSelectedUser
                }
                setActiveComponent={
                  setActivePage
                }
              />
            </div>

            <div
              style={{
                flex: 1,
                minWidth: 0,
              }}
            />

            {/* Header actions */}

            <div className="admission-header-actions">
              <Tooltip title="Change My Password">
                <button
                  type="button"
                  className="admission-header-action"
                  onClick={() =>
                    setPasswordSettingOpen(
                      true
                    )
                  }
                  aria-label="Change My Password"
                >
                  <SafetyCertificateOutlined />
                </button>
              </Tooltip>

              <Tooltip title="Tasks">
                <button
                  type="button"
                  className="admission-header-action"
                  onClick={() =>
                    setTodoOpen(true)
                  }
                  aria-label="Tasks"
                >
                  <CheckSquareOutlined />
                </button>
              </Tooltip>

              <PostTodoList
                open={todoOpen}
                setOpen={setTodoOpen}
              />

              <Darkmode
                darkMode={darkMode}
                setDarkMode={
                  setDarkMode
                }
              />

              {!isMobile && (
                <>
                  <NotificationIcon
                    theme={theme}
                  />

                  <Notice />
                </>
              )}

              <Tooltip title="Profile">
                <div className="admission-profile-container">
                  <div className="admission-profile-avatar">
                    <ProfileImage
                      theme={theme}
                      header
                    />
                  </div>
                </div>
              </Tooltip>
            </div>
          </Header>

          {/* ==================================================
              CONTENT
          ================================================== */}

          <Content
            style={{
              background:
                theme.background,
              padding: isMobile
                ? "9px 8px 12px"
                : "14px 16px 18px",
              minHeight: 0,
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            {/* Page heading */}

            <div className="admission-page-heading">
              <div className="admission-page-heading-left">
                <span className="admission-page-heading-line" />

                <span className="admission-page-heading-title">
                  {activeTitle}
                </span>
              </div>

              {!isMobile && (
                <span className="admission-page-heading-meta">
                  ZION PRAISE ACADEMY • ADMISSION OFFICE • Design by Polu
                </span>
              )}
            </div>

            {/* Main workspace */}

            <motion.div
              key={
                selectedUser
                  ? "user-details"
                  : activePage
              }
              initial={{
                opacity: 0,
                y: 6,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 0.2,
                ease: "easeOut",
              }}
              className={
                darkMode
                  ? "admission-workspace admission-workspace-dark"
                  : "admission-workspace"
              }
              style={{
                padding: isMobile
                  ? 9
                  : 15,
              }}
            >
              {renderPage()}
            </motion.div>
          </Content>
        </Layout>
      </Layout>

      {/* ======================================================
          PASSWORD MODAL
      ====================================================== */}

      <Modal
        open={passwordSettingOpen}
        onCancel={() =>
          setPasswordSettingOpen(false)
        }
        footer={null}
        centered
        width={500}
        destroyOnClose
        className="admission-password-modal"
        title={null}
        styles={{
          content: {
            padding: 0,
            borderRadius: 12,
            overflow: "hidden",
          },
          body: {
            padding: 0,
          },
        }}
      >
        <ChangeUserPassword
          onClose={() =>
            setPasswordSettingOpen(false)
          }
        />
      </Modal>
    </div>
  );
};

export default AdmissionOfficialDashboard;